import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty, sortBy, uniqBy, uniq, isEqual } from 'lodash'
import { getFilters } from '../../api/workspace'
import { handleApiResponse } from '../../utils/request'
import { defaultNotifier } from 'functions/notificationHandler'

import AddFilter from './AddFilter'
import FilterItem from './FilterItem'

class Filter extends React.Component {
  state = {
    visibleFilter: '',
    selectedFilters: null,
    filterColumnNames: this.props.columns,
    filterValues: null
  }

  onReset = () => {
    this.setState(
      {
        visibleFilter: '',
        selectedFilters: null,
        filterColumnNames: this.props.columns
      },
      () => {
        this.addDefaultValue()
      }
    )
  }

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps) {
    const { resetFilter, defaultFilter } = this.props

    const defaultChanged = (
      (defaultFilter && defaultFilter[0] && defaultFilter[0].columns?.length !== nextProps.defaultFilter?.[0]?.columns?.length) ||
      (defaultFilter && defaultFilter[0] && defaultFilter[0].value !== nextProps.defaultFilter?.[0]?.value)
    )

    if (defaultChanged) {
      this.addNextDefaultValue(nextProps.defaultFilter)
    }

    if (nextProps.resetFilter !== resetFilter && nextProps.resetFilter) {
      this.onReset()
    }
  }

  addDefaultValue = () => {
    if (!this.props.defaultFilter) {
      return
    }
    const { defaultFilter } = this.props
    let filters = []

    defaultFilter.map((filterItem) => {
      const {
        value = null,
        readyOnly,
        field,
        columns,
        ids,
        isDefault,
        hideAll,
        hasEmptyValue
      } = filterItem

      const selectedFilters = this.props.columns.find(
        item => item.field === field
      ) || {}

      selectedFilters.filterValue = value
      const allColumns = columns
        && columns.map(group => ({
          label: group,
          name: group,
          customValue: selectedFilters.customValue,
          customField: selectedFilters.customField,
          type: selectedFilters.type
        }))

      selectedFilters.columns = allColumns
      selectedFilters.isDefault = isDefault
      selectedFilters.ids = ids
      selectedFilters.readyOnly = readyOnly
      selectedFilters.hideAll = hideAll
      selectedFilters.hasEmptyValue = hasEmptyValue

      const filterColumnNames = this.props.columns.filter(
        item => item.field !== field
      )

      filters = {
        ...filters,
        [field]: selectedFilters
      }

      return this.setState({
        filterColumnNames: [...this.state.filterColumnNames, filterColumnNames]
      })
    })
    this.setFilterValue(filters)
  }

  addNextDefaultValue = (defaultFilter) => {
    if (!defaultFilter) {
      return
    }
    let filters = []

    defaultFilter.map((filterItem) => {

      const {
        value = null,
        readyOnly,
        field,
        columns,
        ids,
        isDefault,
        showSelectedCount,
        hideAll,
        hasEmptyValue
      } = filterItem

      const selectedFilters = this.props.columns.find(
        item => item.field === field
      ) || {}

      selectedFilters.filterValue = value

      const allColumns = columns
        && columns.map(group => ({
          label: group,
          name: group,
          customValue: selectedFilters.customValue,
          customField: selectedFilters.customField,
          type: selectedFilters.type
        }))

      selectedFilters.columns = allColumns
      selectedFilters.isDefault = isDefault
      selectedFilters.ids = ids
      selectedFilters.readyOnly = readyOnly
      selectedFilters.showSelectedCount = showSelectedCount
      selectedFilters.hideAll = hideAll
      selectedFilters.hasEmptyValue = hasEmptyValue

      const filterColumnNames = this.props.columns.filter(
        item => item.field !== field
      )

      filters = {
        ...filters,
        [field]: selectedFilters
      }

      return this.setState({
        filterColumnNames: [...this.state.filterColumnNames, filterColumnNames]
      })
    })
    if (this.props.mergeDefaultFilter) {
      const merged = {
        ...(this.state.selectedFilters || {}),
        ...filters
      }
      return this.setFilterValue(merged)
    }
    this.props.setFilterOnAddNext && this.setFilterValue(filters)
  }

  componentDidMount() {
    if (this.props.defaultFilter) {
      this.addDefaultValue()
    }
    if (!this.props.filterValues && this.props.filterValuesQuery) {
      this.fetchFilterValues(this.props.filterValuesQuery)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.filterValuesQuery &&
      !isEqual(prevProps.filterValuesQuery, this.props.filterValuesQuery)
    ) {
      if (!this.props.filterValues) {
        this.fetchFilterValues(this.props.filterValuesQuery)
      }
    }
  }

  fetchFilterValues = async (query) => {
    try {
      const data = await getFilters(query)
      handleApiResponse(data, (response) => this.setState({ filterValues: response }), 'filters')
    } catch (error) {
      defaultNotifier(error)
    }
  }

  setFilterValue = (selectedFilters, source) => {
    this.setState({ selectedFilters })
    this.props.onChange(selectedFilters, source)
  }

  onAddFilterType = (selectedHeader) => {
    const { data, disabled } = this.props
    const { filterColumnNames } = this.state

    if (disabled) {
      return false
    }
    let allColumns = []
    let columns = []

    const safeData = Array.isArray(data)
      ? data.filter(item => item && typeof item === 'object')
      : []

    if (selectedHeader.custom) {
      safeData.forEach(item => (item.modules || []).forEach(module => allColumns.push({
        label: module.name,
        name: module.id,
        type: selectedHeader.type
      })))

      allColumns = uniqBy(allColumns, 'label')
    }

    columns = uniq(
      safeData
        .filter(group => group && group[selectedHeader.field])
        .map(group => group[selectedHeader.field]),
    ).map((group) => {
      // If this filter is for tags and the data is an array (list of tags), pass it through as-is
      if (selectedHeader.type === 'tags' && Array.isArray(group)) {
        return group
      }
      if (Array.isArray(group)) {
        let groupArray = {}
        group.forEach(item => {
          if (item.id || item._id) {
            groupArray = {
              ...groupArray,
              label: item.firstName ? `${item.firstName} ${item.lastName ? item.lastName : ''}` : item.name,
              name: item.id || item._id,
              id: item.id || item._id,
              type: selectedHeader.type
            }
          }
        })
        return groupArray
      }
      if (typeof group === 'number') {
        return { label: group, type: selectedHeader.type }
      }

      if (typeof group !== 'object') {
        return { label: group, name: group, type: selectedHeader.type }
      }

      if (selectedHeader.type === 'tags') {
        return group
      }

      if (group && group[0]) {
        return { label: group || [], name: group || [], type: selectedHeader.type }
      }

      return {
        label: group.firstName ? `${group.firstName} ${group.lastName ? group.lastName : ''}` : group.name,
        name: group.id || group._id,
        type: selectedHeader.type
      }
    })

    if (selectedHeader.columns) {
      columns = selectedHeader.columns
    }
    if (selectedHeader.customField) {
      columns = uniq(
        safeData
          .filter(group => group && group[selectedHeader.customField])
          .map(group => group[selectedHeader.customField]),
      ).map((group) => {
        if (typeof group !== 'object') {
          return { label: group, name: group, type: selectedHeader.type }
        }

        if (selectedHeader.type === 'tags') {
          return group
        }
        return {
          label: group.firstName ? `${group.firstName} ${group.lastName ? group.lastName : ''}` : group.name,
          name: group.id || group._id,
          type: selectedHeader.type
        }
      })

      if (selectedHeader.customField.includes('.') && selectedHeader.customField.split('.') && selectedHeader.customField.split('.').length) {
        columns = uniq(
          safeData
            .filter(group => group
              && group[selectedHeader.customField.split('.')[0]]
              && group[selectedHeader.customField.split('.')[0]][selectedHeader.customField.split('.')[1]])
            .map(group => group[selectedHeader.customField.split('.')[0]][selectedHeader.customField.split('.')[1]]),
        ).map((group) => {
          if (typeof group !== 'object') {
            return { label: group, name: group, type: selectedHeader.type }
          }

          if (selectedHeader.type === 'tags') {
            return group
          }
          return {
            label: group.firstName ? `${group.firstName} ${group.lastName ? group.lastName : ''}` : group.name,
            name: group.id || group._id,
            type: selectedHeader.type
          }
        })
      }

    }

    if (selectedHeader.customValue) {
      columns = safeData
        && safeData.map(group => {
          return ({
            label: (selectedHeader.customKey[group[selectedHeader.field]]),
            name: selectedHeader.customKey[group[selectedHeader.field]],
            customValue: selectedHeader.customValue,
            customField: selectedHeader.customField,
            type: selectedHeader.type
          })
        })

      columns = uniqBy(columns, 'label')
    }

    // Override columns from external filterValues when provided
    // Prefer explicit prop, falling back to state (fetched)
    const sourceFilterValues = this.props.filterValues ?? this.state.filterValues
    const providedFilters = (sourceFilterValues?.data?.filters)
      || (Array.isArray(sourceFilterValues) ? sourceFilterValues : null)

    if (providedFilters) {
      const filterValuesKey = selectedHeader.filterValuesKey || selectedHeader.field
      const match = providedFilters.find(f => f.key === filterValuesKey)
      if (match && match.values) {
        const values = match.values
        if (selectedHeader.type === 'tags') {
          // Tags expects columns as array of arrays of strings
          const tagsArray = (Array.isArray(values) ? values : [values])
            .map(v => {
              if (typeof v === 'string' || typeof v === 'number') return String(v)
              if (v && typeof v === 'object') return v.name || v.label || String(v.id || v._id || '')
              return null
            })
            .filter(Boolean)
          if (tagsArray.length) {
            columns = [tagsArray]
          }
        } else {
          const mapped = (Array.isArray(values) ? values : [values]).map(v => {
            if (typeof v === 'string' || typeof v === 'number') {
              return { label: v, name: v, type: selectedHeader.type }
            }
            if (v && typeof v === 'object') {
              const id = v.id || v._id || v.name || v.label
              const label = v.name || v.label || String(id)
              return { label, name: id, id, type: selectedHeader.type }
            }
            return null
          }).filter(Boolean)

          if (mapped.length) {
            columns = mapped
          }
        }
      }
    }

    const allFilters = filterColumnNames
      .filter(header => header.field !== selectedHeader.field)
      .map(header => ({ ...header, isActive: false }))

    this.setState({
      filterColumnNames: allFilters,
      visibleFilter: selectedHeader.field
    })

    const removeEmpty = (columns || []).filter(
      (item) => item && Object.keys(item).length > 0
    )

    const selectedFilters = {
      ...this.state.selectedFilters,
      [selectedHeader.field]: {
        ...selectedHeader,
        columns: selectedHeader.custom ? allColumns : removeEmpty
      }
    }

    this.setState({ selectedFilters })
  }

  onRemoveFilterType = (name, isUpdated, e) => {
    const { onFetchData } = this.props;

    if (e) {
      e.stopPropagation()
    }
    const { filterColumnNames, selectedFilters } = this.state

    const currentFilter = Object.assign({}, selectedFilters || {})
    const toRestore = (selectedFilters && selectedFilters[name]) ? [selectedFilters[name]] : []
    const unFiltered = sortBy(
      [...filterColumnNames, ...toRestore],
      ['id']
    )
    if (currentFilter[name]) {
      delete currentFilter[name].filterValue
      delete currentFilter[name].ids
      delete currentFilter[name]
    }

    if (isUpdated) {
      if (onFetchData && name === 'dismissed') {
        onFetchData()
      }

      return this.setState(
        {
          filterColumnNames: unFiltered,
          selectedFilters: Object.keys(currentFilter).length
            ? currentFilter
            : null
        },
        () => this.props.onChange(this.state.selectedFilters)
      )
    }
    this.setState({
      filterColumnNames: unFiltered,
      selectedFilters: Object.keys(currentFilter).length ? currentFilter : null
    })

  }

  render() {
    const { customClass, disabled, children, showSelectedCount, buttonColor } = this.props
    const { filterColumnNames, visibleFilter, selectedFilters } = this.state

    return (
      <>
        {!isEmpty(selectedFilters)
          && Object.keys(selectedFilters).map((selectedFilter, index) => (
            <FilterItem
              setFilterValue={this.setFilterValue}
              key={index}
              hideAll={selectedFilters[selectedFilter]?.hideAll}
              disabled={disabled}
              isDefault={selectedFilters[selectedFilter]?.isDefault}
              customClass={customClass}
              buttonColor={buttonColor}
              visibleFilter={visibleFilter}
              onRemove={this.onRemoveFilterType}
              data={selectedFilters[selectedFilter]}
              selectedFilters={selectedFilters}
              showSelectedCount={showSelectedCount ? showSelectedCount : selectedFilters[selectedFilter]?.showSelectedCount}
            />
          ))}
        {this.props.visibleAddButton && (
          <AddFilter
            disabled={disabled}
            customClass={customClass}
            onRemove={this.onRemoveFilterType}
            filters={filterColumnNames}
            onAdd={this.onAddFilterType}
            defaultFilter={this.props.defaultFilter}
          />
        )}
        {children}
      </>
    )
  }
}

Filter.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  onChange: PropTypes.func,
  resetFilter: PropTypes.bool,
  disabled: PropTypes.bool,
  customClass: PropTypes.string,
  defaultFilter: PropTypes.array,
  visibleAddButton: PropTypes.bool,
  showSelectedCount: PropTypes.bool,
  filterValues: PropTypes.any,
  filterValuesQuery: PropTypes.any
}

Filter.defaultProps = {
  visibleAddButton: true
}

export default Filter